// _safeMap — Array.isArray guard for SDK fetch-transform callbacks.
//
// The fetch plugin passes the raw SDK response envelope to `transform`.
// When the SDK returns a paginated wrapper `{ data: [...] }`, an error
// object, or `null` instead of a plain array, `(rows || []).map(fn)` throws
// because `rows || []` short-circuits to the non-array truthy value.
//
// Usage in a fetch transform:
//   transform: (rows) => ({ items: safeMap(rows, rowToItem) })
//
// This keeps the transform side-effect free and avoids the silent empty-state
// bug where the page renders with no data but also no error in the console.
export const safeMap = (rows, fn) =>
  Array.isArray(rows) ? rows.map(fn) : []
